import { useQuery } from "@apollo/client";
import { get } from "lodash";

import { useWorkspace } from "src/contexts/global/WorkspaceContext";
import { getRootType } from "src/util/customerConfig";
import { listTeamsForGoalsExplore as listTeamsQuery } from "src/pages/TeamListPage/queries.graphql";

/**
 * @param {Object} param0
 * @param {string[]} param0.search
 * @param {boolean} param0.includeEmptyGroups
 * @param {boolean} param0.includeTotalCount
 * @param {number} param0.limit
 * @param {boolean} param0.skip
 * @param {Function} param0.onComplete
 * @returns {Object}
 * @returns {Object[]} rootTeams
 * @returns {Error} error
 * @returns {boolean} loading
 */
const useFetchRootTeams = ({
  search = [],
  includeEmptyGroups = true,
  includeTotalCount = true,
  limit = 15,
  skip = false,
  onComplete,
} = {}) => {
  const workspace = useWorkspace();

  const rootType = getRootType(workspace.config.groupTypes);
  const rootTypeName = rootType ? rootType.id : "Function";

  const { data, error, loading } = useQuery(listTeamsQuery, {
    variables: {
      typeFilters: [rootTypeName],
      search,
      includeEmptyGroups,
      includeTotalCount,
      limit,
    },
    skip,
    onCompleted: (result) => {
      onComplete?.(result);
    },
  });

  const rootTeams = get(data, "result.groups", []);

  return { rootTeams, error, loading };
};

export default useFetchRootTeams;
